import * as Yup from "yup";

const validationDefault = {
  refusalInstructions: Yup.string()
    .typeError("Instruções de recusa é obrigatório")
    .required("Instruções de recusa é obrigatório")
};

export const validationSchemaEdit = Yup.object().shape(validationDefault);
